// extracted by mini-css-extract-plugin
module.exports = {"EmailInfo":"EmailInfo_EmailInfo__33FG9","Links":"EmailInfo_Links__bGwDd","Invalid":"EmailInfo_Invalid__2gd8G"};